<template>
    <svg :width="width" :height="height" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.5001 21.0834C16.7928 21.0834 21.0834 16.7928 21.0834 11.5C21.0834 6.20729 16.7928 1.91669 11.5001 1.91669C6.20735 1.91669 1.91675 6.20729 1.91675 11.5C1.91675 16.7928 6.20735 21.0834 11.5001 21.0834Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M9.58325 7.66669L15.3333 11.5L9.58325 15.3334V7.66669Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>
<script>
export default {
  props: {
    fill: {
      type: String,
      default: '#FFFFFF'
    },
    width: {
      type: Number,
      default: 23
    },
    height: {
      type: Number,
      default: 23
    }
  }
}
</script>
